// Single source of truth for the species vocabulary shared by
// ViewDrawOdds.vue, SearchMapView.vue, SavedHuntsMapView.vue, and the
// manual points entry UI.
//
// Two vocabularies exist:
//   - draw_points-side names: how species are stored in the draw_points
//     table (e.g. "Limited-entry Bull Elk"). Manual points entry MUST
//     store species in this vocabulary or odds auto-fill breaks.
//   - API-side names: the raw strings the draw-odds backend expects
//     (e.g. "LIMITED ENTRY ELK").

/**
 * Draw_points-side species names (the keys of drawPointsToApiSpecies,
 * in that map's order).
 */
export const SPECIES_LIST = [
  "General-season Buck Deer",
  "Limited-entry Buck Deer",
  "Limited-entry Bull Elk",
  "Limited-entry Buck Pronghorn",
  "Bison",
  "Desert Bighorn Sheep",
  "Rocky Mountain Bighorn Sheep",
  "Mountain Goat",
  "Bull Moose",
  "Bear"
];

/**
 * API-side species names (the values of drawPointsToApiSpecies), in the
 * order the species dropdowns in ViewDrawOdds/SearchMapView historically
 * displayed them.
 */
export const API_SPECIES_LIST = [
  "General-season Buck Deer",
  "Buck Deer",
  "LIMITED ENTRY ELK",
  "LIMITED ENTRY PRONGHORN",
  "BISON",
  "DESERT BIGHORN SHEEP",
  "MTN GOAT",
  "BULL MOOSE",
  "ROCKY MTN SHEEP",
  "Bear"
];

/**
 * Map draw_points species names to the raw species strings the backend
 * expects. (Verbatim from ViewDrawOdds.vue, the authoritative copy.)
 */
export const drawPointsToApiSpecies = {
  "General-season Buck Deer": "General-season Buck Deer",
  "Limited-entry Buck Deer": "Buck Deer",
  "Limited-entry Bull Elk": "LIMITED ENTRY ELK",
  "Limited-entry Buck Pronghorn": "LIMITED ENTRY PRONGHORN",
  "Bison": "BISON",
  "Desert Bighorn Sheep": "DESERT BIGHORN SHEEP",
  "Rocky Mountain Bighorn Sheep": "ROCKY MTN SHEEP",
  "Mountain Goat": "MTN GOAT",
  "Bull Moose": "BULL MOOSE",
  "Bear": "Bear",
  // When I find more, add here
};

/**
 * Map API species names to draw_points species names
 * (exact inverse of drawPointsToApiSpecies).
 */
export const apiToDrawPointsSpecies = {
  "General-season Buck Deer": "General-season Buck Deer",
  "Buck Deer": "Limited-entry Buck Deer",
  "LIMITED ENTRY ELK": "Limited-entry Bull Elk",
  "LIMITED ENTRY PRONGHORN": "Limited-entry Buck Pronghorn",
  "BISON": "Bison",
  "DESERT BIGHORN SHEEP": "Desert Bighorn Sheep",
  "ROCKY MTN SHEEP": "Rocky Mountain Bighorn Sheep",
  "MTN GOAT": "Mountain Goat",
  "BULL MOOSE": "Bull Moose",
  "Bear": "Bear"
};
